"use client";

import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { BaseInput } from "@/ui/primitives/BaseInput";
import type { ComponentProps } from "react";

type PasswordInputProps = Omit<
  ComponentProps<typeof BaseInput>,
  "type" | "iconAfter"
>;

export function PasswordInput(props: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <BaseInput
      {...props}
      type={visible ? "text" : "password"}
      iconAfter={
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setVisible((show) => !show)}
          disabled={props.disabled}
          className="text-secondary hover:text-primary transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? (
            <EyeOff className="w-5 h-5" aria-hidden />
          ) : (
            <Eye className="w-5 h-5" aria-hidden />
          )}
        </button>
      }
    />
  );
}
